export class TreasuryBankingTransactionDto {
  id?: number;
  businessEntityId?: number;
  businessEntityBankId?: number;
  transactionTypeId?: number;
  transactionType?: string;
  date: Date;
  source: string;
  description: string;
  amount: number;
  balance: number;
  amountDirection: string;
  fireTransferId?: string;
  fireBatchId?: string;
  fireId: number;
  status: string;
  transactionId?: string;
}

export class TreasuryTransactionPaginatedDto {
  code?: string;
  items: TreasuryBankingTransactionDto[];
  meta?: any;
  links?: any;
}

export class TreasuryBankingTransactionResponseDto {
  items: TreasuryBankingTransactionDto[];
  meta?: any;
  links?: any;
  transactionTypePaginated?: TreasuryTransactionPaginatedDto[];
}
